import { createSelector } from '@reduxjs/toolkit';

import { DEFAULT_DEADLINE_VALUE } from '../../reducers/filter/helpers';

import { getFilters } from './getFilters';

export const getDeadline = createSelector(getFilters, state => state.deadline);

export const getDeadlineVariants = createSelector(getFilters, state => state.deadlineVariants);

export const getDeadlineVariantsForSelect = createSelector(getDeadlineVariants, deadlineVariants => {
  const options = deadlineVariants.map(variant => ({ label: `До конца ${variant}`, value: variant }));

  return [{ label: 'Не важно', value: DEFAULT_DEADLINE_VALUE }, ...options];
});
